import { addNamespace } from '@Utils';

export const createActionName = (...p: string[]) => p.join('/');

export const toResolved = (p: string) => createActionName(p, 'resolved');
export const toRejected = (p: string) => createActionName(p, 'rejected');

export const toThunk = (
	p: string,
): { action: string; resolved: string; rejected: string } => {
	const actionName = addNamespace(p);
	return {
		action: actionName,
		resolved: toResolved(actionName),
		rejected: toRejected(actionName),
	};
};
